module.exports = __webpack_public_path__ + "img/upload.2ff29d6e.svg";